function safeCapture(diagnostics,scope,error,meta={}){
  try{diagnostics?.capture?.(scope,error,meta);}catch{}
}

export function createAccountDeletionService({
  remote,
  auth,
  diagnostics,
  confirmDelete=()=>Boolean(globalThis.confirm?.('Usunąć konto Dymistrz na stałe? Tej operacji nie można cofnąć.')),
  isOnline=()=>globalThis.navigator?.onLine!==false
}={}){
  if(typeof remote?.deleteAccount!=='function')throw new TypeError('Account deletion remote with deleteAccount() is required');
  if(typeof auth?.signOutLocal!=='function')throw new TypeError('Auth adapter with local sign-out is required');

  async function deleteAccount(){
    if(!isOnline())return Object.freeze({ok:false,status:'offline'});
    if(!confirmDelete())return Object.freeze({ok:false,status:'cancelled'});

    let remoteResult;
    try{
      remoteResult=await remote.deleteAccount();
    }catch(error){
      safeCapture(diagnostics,'account.delete.remote',error,{
        code:String(error?.code||'ACCOUNT_DELETE_FAILED'),
        retryable:Boolean(error?.retryable),
        timeout:Boolean(error?.timeout),
        cancelled:Boolean(error?.cancelled)
      });
      throw error;
    }
    if(!remoteResult?.ok||remoteResult?.deleted!==true){
      const failure=Object.assign(new Error('ACCOUNT_DELETE_NOT_CONFIRMED'),{code:'ACCOUNT_DELETE_NOT_CONFIRMED'});
      safeCapture(diagnostics,'account.delete.response',failure,{code:failure.code});
      throw failure;
    }

    let localSessionCleared=true;
    try{await auth.signOutLocal();}
    catch(error){
      localSessionCleared=false;
      safeCapture(diagnostics,'account.delete.local-session-cleanup',error);
    }

    return Object.freeze({
      ok:true,
      status:'deleted',
      localSessionCleared,
      removedFiles:Number.isFinite(Number(remoteResult.removedFiles))?Number(remoteResult.removedFiles):0
    });
  }

  return Object.freeze({deleteAccount});
}
